<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    mobile-break-point="960"
    width="260"
    style="top:0; left:0; overflow-y:auto;"
    fixed
    expand-on-hover="true"
  >
    <v-list>
      <v-img
        :src="image"
        height="100%"
      >
        <v-list-tile avatar>
          <v-list-tile-avatar color="general">
            {{ userName.substr(0,1).toUpperCase() }}
          </v-list-tile-avatar>
          <v-list-tile-title class="title">
            {{ userName.toUpperCase() }}
          </v-list-tile-title>
        </v-list-tile>
        <v-divider/>
        <!--        <v-list-tile-->
        <!--          v-if="responsive"-->
        <!--        >-->
        <!--          <v-text-field-->
        <!--            class="purple-input search-input"-->
        <!--            label="Search..."-->
        <!--            color="purple"-->
        <!--          />-->
        <!--        </v-list-tile>-->
        <!--        <v-list-tile-->
        <!--          v-for="(link, i) in links"-->
        <!--          :key="i"-->
        <!--          :to="link.to"-->
        <!--          :active-class="color"-->
        <!--          avatar-->
        <!--          class="v-list-item"-->
        <!--        >-->
        <!--          <v-list-tile-action>-->
        <!--            <v-icon>{{ link.icon }}</v-icon>-->
        <!--          </v-list-tile-action>-->
        <!--          <v-list-tile-title-->
        <!--            v-text="link.text"-->
        <!--          />-->
        <!--        </v-list-tile>-->
        <!-- sub menu but vue-router not working!! -->
        <v-list-tile
          v-for="(link, i) in links"
          v-if="!link.subLinks"
          :disabled="hasPermission(link.permission) === false"
          :key="i"
          :to="link.to"
          :href="link.href"
          :active-class="color"
          avatar
          class="v-list-item"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="link.text"
          />
        </v-list-tile>

        <v-list-group
          v-else
          :key="link.text"
          no-action
        >
          <template v-slot:activator>
            <v-list-tile
              avatar
              class="v-list-item-group">
              <v-list-tile-action>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title
                v-text="link.text"
              />
            </v-list-tile>
          </template>

          <v-list-tile
            v-for="sublink in link.subLinks"
            :to="sublink.to"
            :key="sublink.text"
            :active-class="color"
            avatar
            class="v-list-item"
            :disabled="hasPermission(sublink.permission) === false"
          >
            <v-list-tile-title v-text="sublink.text" />
            <v-list-tile-action>
              <v-icon>{{ sublink.icon }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>

        </v-list-group>

      </v-img>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  /* eslint-disable */
  // Fool way of hide/disable menu access (change to BE service later)
  import {mapGetters, mapMutations, mapState} from 'vuex'

  export default {
  data: () => ({
    logo: require('@/assets/img/redditicon.png'),
    //TODO: get it from state vuexstore,  state get it from localstorage
    userName: localStorage.getItem('username'),
    links: [
      {
        to: '/',
        icon: 'mdi-view-dashboard',
        text: 'Dashboard',
        permission: 'MA_DASHBOARD'
      },
      {
        // aplikasi terpisah (Next.js) di origin yang sama, jadi localStorage.token
        // ikut terbawa tanpa login kedua kali — lihat SsoBridge.vue di sisi sana
        href: '/reimbursement/sso',
        icon: 'mdi-clock-check-outline',
        text: 'Absensi & Reimbursement',
        permission: 'MA_DASHBOARD'
      },
      {
        icon: 'mdi-database',
        text: 'Master Data',
        subLinks: [
          {
            text: 'Company',
            to: '/dashboard/md/company',
            icon: 'mdi-table-edit',
            permission: ['MA_MASTER_DATA','MA_MD_CUSTOMER_READ','MA_MD_COMPANY_READ']
          },
          {
            text: 'Customer',
            to: '/dashboard/md/customer',
            icon: 'mdi-table-edit',
            permission: ['MA_MASTER_DATA','MA_MD_CUSTOMER_READ','MA_MD_COMPANY_READ']
          },
          {
            text: 'Exchange Rate',
            to: '/dashboard/md/exchrate',
            icon: 'mdi-table-edit',
            permission: 'MA_MASTER_DATA'
          },
          {
            text: 'Price Rule',
            to: '/dashboard/md/pricerule',
            icon: 'mdi-table-edit',
            permission: 'MA_MASTER_DATA'
          },
          {
            text: 'Item Material',
            to: '/dashboard/md/item',
            icon: 'mdi-table-edit',
            permission: 'MA_MASTER_DATA'
          },
          {
            text: 'Supplier',
            to: '/dashboard/md/supplier',
            icon: 'mdi-table-edit',
            permission: 'MA_MASTER_DATA'
          },
        ]
      },
      {
        to: '/dashboard/visit',
        icon: 'mdi-map-marker-outline',
        text: 'Visit / Activity',
        permission: 'MA_VISIT'
      },
      {
        to: '/dashboard/lead',
        icon: 'mdi-message-text-outline',
        text: 'Lead Website',
        permission: 'MA_LEAD'
      },
      {
        to: '/dashboard/shodan',
        icon: 'mdi-file-document',
        text: 'Shodan',
        permission: 'MA_SHODAN'
      },
      {
        to: '/dashboard/sales',
        icon: 'mdi-cart-plus',
        text: 'Admin Sales',
        permission: 'MA_SALES'
      },
      {
        to: '/dashboard/quotation',
        icon: 'mdi-file-document',
        text: 'Quotation',
        permission: 'MA_QUOTATION'
      },
      {
        to: '/dashboard/project',
        icon: 'mdi-calendar-clock',
        text: 'Project',
        permission: 'MA_PROJECT'
      },
      {
        icon: 'mdi-book-multiple-variant',
        text: 'Report',
        subLinks: [
          {
            text: 'Project',
            to: '/dashboard/report/project',
            icon: 'mdi-book-open-page-variant', //mdi-book-open
            permission: ['MA_REPORT','MA_REPORT_PROJECT']
          },
        ]
      },
      {
        to: '/dashboard/account',
        icon: 'mdi-account-multiple',
        text: 'Account',
        permission: 'MA_ACCOUNT'
      }
      // {
      //   to: '/dashboard/user-profile',
      //   icon: 'mdi-account',
      //   text: 'User Profile'
      // },
      // {
      //   to: '/dashboard/table-list',
      //   icon: 'mdi-clipboard-outline',
      //   text: 'Table List'
      // },
      // {
      //   to: '/dashboard/user-tables',
      //   icon: 'mdi-table-edit',
      //   text: 'Users Table'
      // },

      // {
      //   to: '/dashboard/complex',
      //   icon: 'mdi-table-edit',
      //   text: 'Complex Table'
      // },
      // {
      //   to: '/dashboard/typography',
      //   icon: 'mdi-format-font',
      //   text: 'Typography'
      // },
      // {
      //   to: '/dashboard/icons',
      //   icon: 'mdi-chart-bubble',
      //   text: 'Icons'
      // },
      // {
      //   to: '/dashboard/maps',
      //   icon: 'mdi-map-marker',
      //   text: 'Maps'
      // },
      // {
      //   to: '/dashboard/notifications',
      //   icon: 'mdi-bell',
      //   text: 'Notifications'
      // }
    ],
    responsive: false
  }),
  computed: {
    ...mapState('app', ['image', 'color']), // module=app
    ...mapState(['user']), //without modules
    ...mapGetters(['hasPermission']), // without modules
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    },
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }
    div.v-responsive.v-image > div.v-responsive__content {
      overflow-y: auto;
      scrollbar-width: none;
    }
    .v-list__group__items {
      padding-left: 15px;
    }
    /*.theme--dark.v-list .v-list__group__header:hover{*/
    /*  background: rgba(200, 200, 200, 0.2)*/
    /*}*/

    .v-list .v-list__group__header:hover {
      background: #2196F3
    }
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
  }
  /* Optional: show position indicator in red */
  ::-webkit-scrollbar-thumb {
    background: #777777;
  }

  #profileImage {
    width: 150px;
    /*height: 150px;*/
    border-radius: 50%;
    background: #295ba8;
    font-size: 35px;
    color: #fff;
    text-align: center;
    /*line-height: 150px;*/
    margin: 20px 0;
  }
</style>
